// extracted by mini-css-extract-plugin
export default {"list":"CardList_list__SuX5a"};